import * as types from "./mutations.types";
import { http, urls } from "../../../services";

import {getAnalytics,logEvent} from "firebase/analytics";

export const actionSetAnalyze = async ({ commit }, payload) => {
  commit(types.SET_ANALYZE, payload);
};

export const actionSetPositive = async ({ commit }, payload) => {
  commit(types.SET_POSITIVE, payload);
};

export const actionSetNegative = async ({ commit }, payload) => {
  commit(types.SET_NEGATIVE, payload);
};

export const actionSetAnalyzePresential = async ({ commit }, payload) => {
  commit(types.SET_ANALYZE_PRESENTIAL, payload);
};

export const actionLoadAnalyze = async ({ dispatch }) => {
  await http
    .GET(urls.analyze)
    .then(response => {
      let data = [];
      response.data.forEach(monitoring => {
        let date = new Date(monitoring.date);
        monitoring.date = date.toLocaleDateString("pt-BR", { timeZone: "UTC" });

        data.push(monitoring);
      });

      dispatch("actionSetAnalyze", data);
    })
    .catch(error => console.log(error));
};

export const actionEditAnalyze = async ({ dispatch }, payload) => {
  return await http
    .PUT(urls.monitoring, payload.id, {
      technical_id: payload.user_id,
      state: payload.state
    })
    .then(() => {
      dispatch("actionLoadAnalyze");
      let state = payload.state
      if(state ==="Analise presencial" ){
          state.replace(" ","_")
      }
     logEvent(getAnalytics(),`monitoring_${state}`)
    })
    .catch(error => {
      console.log(error)});
};

export const actionLoadPositive = async ({ dispatch }) => {
  await http
    .GET(urls.positive)
    .then(response => {
      let data = [];
      response.data.forEach(monitoring => {
        let date = new Date(monitoring.date);
        monitoring.date = date.toLocaleDateString("pt-BR", { timeZone: "UTC" });
        data.push(monitoring);
      });
      dispatch("actionSetPositive", data);
    })
    .catch(error => console.error(error));
};

export const actionLoadNegative = async ({ dispatch }) => {
  await http
    .GET(urls.negative)
    .then(response => {
      let data = [];
      response.data.forEach(monitoring => {
        let date = new Date(monitoring.date);
        monitoring.date = date.toLocaleDateString("pt-BR", { timeZone: "UTC" });

        data.push(monitoring);
      });
      dispatch("actionSetNegative", data);
    })
    .catch(error => console.error(error));
};

export const actionLoadAnalyzePresential = async ({ dispatch }) => {
  await http
    .GET(urls.analyzePresential)
    .then(response => {
      let data = [];
      response.data.forEach(monitoring => {
        let date = new Date(monitoring.date);
        monitoring.date = date.toLocaleDateString("pt-BR", { timeZone: "UTC" });

        data.push(monitoring);
      });
      dispatch("actionSetAnalyzePresential", data);
    })
    .catch(error => console.error(error));
};
